// src/pages/auth/CompanyRegisterPage.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import LanguageSwitcherAuth from '../../components/LanguageSwitcherAuth';
import '../../styles/auth.css';

export default function CompanyRegisterPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation('auth');

  async function handleSubmit(e) {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      return setError(t('validation.passwordsDoNotMatch'));
    }
    
    if (password.length < 6) {
      return setError(t('validation.passwordTooShort'));
    }
    
    try {
      setError('');
      setLoading(true);
      await register(email, password, companyName);
      navigate('/admin/dashboard');
    } catch (error) {
      console.error(error);
      setError(t('messages.registerError') + error.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-container">
      <LanguageSwitcherAuth />
      <div className="auth-form-container">
        <div className="auth-logo-container">
          <img 
            src="/48x48.png" 
            srcSet="/48x48.png 1x, /96x96.png 2x, /144x144.png 3x"
            alt={t('alt.klokifyLogo')} 
            className="auth-logo" 
          />
          <h1 className="auth-brand-name">Klokify</h1>
        </div>
        <h2>{t('titles.registerCompany')}</h2>
        {error && <div className="auth-error">{error}</div>}
        
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="companyName">{t('labels.companyName')}</label>
            <input
              type="text"
              id="companyName"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">{t('labels.email')}</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">{t('labels.password')}</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="confirmPassword">{t('labels.confirmPassword')}</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          
          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? t('buttons.creatingAccount') : t('buttons.register')}
          </button>
        </form>
        
        <div className="auth-links">
          <Link to="/admin/login">{t('links.alreadyHaveAccount')}</Link>
        </div>
      </div>
    </div>
  );
}